mutation DeleteGroupFeed($campaignId: ID!, $group: String!) {
    deleteGroupFeed(campaignId: $campaignId, group: $group)
}
